import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLanguage } from "hooks";
import { Skeletons } from "components";
import MagazineInfo from "./MagazineInfo";
import Archives from "../Archives";
import { STORAGE_URL } from "constants";
import Slider from "../Slider";

/*
step 1:
to show magazine details 
step 2:
to show a magazine edition details 
step 2:
to show magazine editions list 
*/

export default function MagazineDetails({
  bookData, // Book data object that contains book details from the database
  link: showLink,
  setLink: showSetLink, // to set the link
}) {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const [step, setStep] = React.useState(1);
  const [link, setLink] = React.useState({});

  const setStepHandler = (step) => {
    setStep(step);
    window.scrollTo(0, 0); // scroll to the tom on any change in steps
  };

  React.useEffect(() => {
    setStep(1);
    setLink({});
  }, [bookData]);


  return (
    <>
      {step === 1 ? (
        <section id="info" className="mb-3">
          <Container id="info_container" className="position-relative">
            {bookData && bookData.details ? (
              <>
                <Row>
                  <Col xl={4} lg={5} md={5} sm={12} xs={12}>
                    {/* set items to slider to display images  */} <Slider>
                      {bookData.details.links.map((link, index) => (
                        <div
                          key={`${index}`}
                          onClick={() => {
                            setStepHandler(2);
                            setLink(link);
                          }}
                          role="button"
                        >
                          <img
                            src={`${STORAGE_URL}${link.cover_image}`}
                            title={`figure ${index + 1}`}
                            alt={`figure ${index + 1}`}
                            className="w-100"
                          />
                        </div>
                      ))}
                    </Slider>
                    {bookData.details.links?.length > 0 && (
                      <div className="text-center"> {/* to show all magazine editions*/}
                        <button
                          className="btn btn-outline-primary px-5"
                          onClick={() => setStepHandler(3)}
                        >
                          {language.archives}
                        </button>
                      </div>
                    )}
                  </Col>
                  <Col xl={8} lg={7} md={7} sm={12} xs={12}>
                    <Row>
                      <Col xl={7} xs={12}>
                        <Row className="pt-3  pt-lg-5 px-lg-5">
                          <Col xs={12}>
                            <ul className="list-group list-group-horizontal bg-transparent pb-4">
                              {bookData.details.links_types?.length > 0 &&
                                bookData.details.links_types?.map( /* display links types icons */
                                  (item, index) => (
                                    <li
                                      key={index}
                                      className="list-group-item d-flex justify-content-center align-items-center gap-2 text-light-5 bg-transparent border-0 pe-0"
                                    >
                                      <img
                                        src={`${STORAGE_URL}${item.icon}`}
                                        alt={item.type}
                                        width={20}
                                      />
                                      <p className="fw-normal text-light5">
                                        {item.type}
                                      </p>
                                    </li>
                                  )
                                )}
                            </ul>
                          </Col>
                          <Col xs={12}>
                            <div>
                              <Col xs={12}>
                                <h2 className="text-primary fw-medium h5">
                                  {bookData.details.name}
                                </h2>
                              </Col>
                              <Col xs={12}>
                                <h4 className="text-black fw-normal">
                                  {bookData.details.sub_title}
                                </h4>
                              </Col>

                              <Col xs={12}>
                                <ul className=" list-unstyled mt-4">
                                  {[
                                    {
                                      label: language.breastSide,
                                      value: bookData.details.publisher?.name,
                                    },
                                    {
                                      label: language.place,
                                      value: bookData.details.publisher?.place,
                                    },
                                    {
                                      label: language.breastFrequency,
                                      value:
                                        bookData.details.breast_frequency_id,
                                    },
                                  ].map( /* show details label: value*/
                                    (item, index) =>
                                      item?.value && (
                                        <li key={index}>
                                          <h6 className="fw-medium text-blue w-100">
                                            {item.label}: {item.value}
                                          </h6>
                                        </li>
                                      )
                                  )}
                                </ul>
                              </Col>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col xl={5} xs={12}>
                        {bookData.details.schools &&
                          bookData.details.schools.length > 0 && ( // if there is no links and no schools the section will not display
                            <Row className="bg-white rounded-3 p-4 mt-4 mt-xl-5 mb-4 g-4">
                              <Col xs={12}>
                                <p className="fw-normal text-light5 mb-4 mt-xl-4">
                                  {
                                    language[
                                      `theBookAvailable${bookData.details.book_section_id}`
                                    ]
                                  }{" "}
                                  <strong className="text-primary fw-bold">
                                    (
                                    {bookData.details.schools.filter(
                                      ({ id }) => id === 7
                                    ).length > 0
                                      ? bookData.details.schools
                                          .filter(({ id }) => id === 7)
                                          .map((item, index) => (
                                            <span key={item.id}>
                                              {item.name}{" "}
                                            </span>
                                          ))
                                      : bookData.details.schools.map(
                                          (item, index) => (
                                            <span key={item.id}>
                                              {item.name}{" "}
                                              {index <
                                                bookData.details.schools
                                                  .length -
                                                  1 && ","}
                                            </span>
                                          )
                                        )}
                                    )
                                  </strong>
                                </p>
                              </Col>
                            </Row>
                          )}
                      </Col>
                      <Col xs={12}>
                        <Row className=" px-lg-5">
                          <Col xs={12}> {/* show html text as html */}
                            <p
                              className="fw-normal text-light5"
                              dangerouslySetInnerHTML={{
                                __html: bookData.details.description,
                              }}
                            ></p>
                          </Col>

                          <Col xs={12}>
                            <p
                              className="fw-normal text-light5 mt-4"
                              dangerouslySetInnerHTML={{
                                __html: bookData.details.notes,
                              }}
                            ></p>
                          </Col>

                          <Col xs={12}>
                            <p
                              className="fw-normal text-light5 mt-4"
                              dangerouslySetInnerHTML={{
                                __html: bookData.details.tags,
                              }}
                            ></p>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </>
            ) : (
              <Skeletons.BookDetailsSkeleton />
            )}
          </Container>
        </section>
      ) : step === 2 ? (
        <MagazineInfo
          link={link}
          book={bookData.details}
          setStep={setStepHandler}
          showLink={showLink}
          showSetLink={showSetLink}
        />
      ) : (
        <Archives
          links={bookData.details.links}
          setStep={setStepHandler}
          setLink={setLink}
        />
      )}
    </>
  );
}
